import i18next from 'i18next';
import { makeAutoObservable } from 'mobx';
import { MobxRootStore } from './mobx.store';

/**
 * @deprecated
 * Temporary solution. Added due to typing problems in some components.
 */

export class AppSettingStore {
  mobxStore: MobxRootStore;

  private _i18next: typeof i18next = i18next;

  constructor(mobxStore: MobxRootStore) {
    this.mobxStore = mobxStore;
    makeAutoObservable(this);
  }

  setI18next = (i18n: typeof i18next) => {
    /* This is a shallow copy of i18next. Prototype is missing. */
    this._i18next = { ...i18n, t: i18n.t };
  };

  get i18next() {
    return this._i18next;
  }
}
